export function Loading({ label = "Wird geladen…" }: { label?: string }) {
  return (
    <div
      className="flex items-center justify-center gap-3 p-8 text-slate-500"
      role="status"
      aria-live="polite"
    >
      <span
        className="inline-block h-5 w-5 animate-spin rounded-full border-2 border-slate-300 border-t-slate-600"
        aria-hidden="true"
      />
      <span>{label}</span>
    </div>
  );
}
